/* LIT Carta — scroll-linked parallax. Transform only, one rAF per frame, off for reduced motion and in the editor. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;

  var root = document.documentElement;
  var bar = document.createElement('div');
  bar.className = 'lit-progress';
  bar.setAttribute('aria-hidden', 'true');

  var hero, cats, editorial, frame, stories;
  var small = window.matchMedia('(max-width: 749px)');
  var ticking = false;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  // 0 when the element's top meets the viewport bottom, 1 when its bottom leaves the top
  function progress(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight;
    return clamp((vh - r.top) / (vh + r.height), 0, 1);
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > -100 && r.top < window.innerHeight + 100;
  }

  function scroller() {
    var w = document.querySelector('.page-wrapper');
    return w && w.scrollHeight > w.clientHeight + 10 ? w : document.scrollingElement;
  }

  function update() {
    ticking = false;
    var k = small.matches ? 0.55 : 1;
    var s = scroller();
    var max = s.scrollHeight - s.clientHeight;
    root.style.setProperty('--progress', max > 0 ? (s.scrollTop / max).toFixed(4) : 0);

    if (hero && inView(hero)) {
      var h = hero.getBoundingClientRect();
      var t = clamp(-h.top / h.height, 0, 1);
      hero.style.setProperty('--hero-y', (t * 120 * k).toFixed(1) + 'px');
      hero.style.setProperty('--hero-txt', (t * -60 * k).toFixed(1) + 'px');
      hero.style.setProperty('--hero-fade', (1 - t * 0.9).toFixed(3));
      hero.style.setProperty('--hero-rot', (t * 14).toFixed(2) + 'deg');
    }

    if (cats && inView(cats)) {
      var pc = progress(cats);
      cats.querySelectorAll('.lit-cats__tile').forEach(function (tile, i) {
        tile.style.setProperty('--py', (((pc - 0.5) * (i % 2 ? -36 : 36)) * k).toFixed(1) + 'px');
      });
    }

    if (editorial && inView(editorial)) {
      var pe = progress(editorial) - 0.5;
      editorial.style.setProperty('--orq-a', (pe * -140 * k).toFixed(1) + 'px');
      editorial.style.setProperty('--orq-b', (pe * 140 * k).toFixed(1) + 'px');
      editorial.style.setProperty('--orq-r', (pe * 10).toFixed(2) + 'deg');
    }

    if (frame && inView(frame)) {
      var pf = progress(frame);
      frame.style.setProperty('--frame-s', (0.92 + clamp(pf * 2, 0, 1) * 0.08).toFixed(4));
    }

    if (stories && inView(stories)) {
      var ps = progress(stories) - 0.5;
      stories.querySelectorAll('.lit-storyrow > *').forEach(function (el, i) {
        el.style.setProperty('--sy', (ps * (i % 2 ? 50 : -30) * k).toFixed(1) + 'px');
      });
    }
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  function start() {
    document.body.appendChild(bar);
    hero = document.querySelector('.lit-hero');
    cats = document.querySelector('.lit-cats');
    editorial = document.querySelector('.lit-editorial');
    frame = document.querySelector('.lit-video__frame');
    stories = document.querySelector('.lit-stories');
    window.addEventListener('scroll', onScroll, { passive: true });
    var w = document.querySelector('.page-wrapper');
    if (w) w.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
